<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>LABELISATION DES PME/PMI</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>LABELISATION DES PME/PMI</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Main Content -->
<section class="main-content">
    <div class="container">
        <!-- Introduction -->
        <div class="row mb-5">
            <div class="col-lg-8 mx-auto">
                <div class="intro-card">
                    <div class="card-icon">
                        <i class="icofont-award"></i>
                    </div>
                    <h2>Qu'est-ce que la labellisation ?</h2>
                    <p>
                        C'est une activité supplémentaire et complémentaire du programme classique d'accompagnement des sous-traitants 
                        du programme SPX UNIDO, qui renforce le mécanisme d'accompagnement existant.
                    </p>
                </div>
            </div>
        </div>

        <!-- Process Steps -->
        <div class="row mb-5">
            <div class="col-lg-12">
                <h3 class="section-title">Le processus de labellisation</h3>
            </div>
        </div>

        <div class="row">
            <!-- Step 1 -->
            <div class="col-lg-4 mb-4">
                <div class="step-card">
                    <div class="step-header">
                        <div class="step-number">01</div>
                        <div class="step-icon">
                            <i class="icofont-search-document"></i>
                        </div>
                    </div>
                    <h3>Profilage</h3>
                    <div class="step-content">
                        <p>Recensement et renseignement dans la base de données des informations générales d'identification, des qualifications techniques et spécifiques des PME / PMI.</p>
                    </div>
                </div>
            </div>

            <!-- Step 2 -->
            <div class="col-lg-4 mb-4">
                <div class="step-card">
                    <div class="step-header">
                        <div class="step-number">02</div>
                        <div class="step-icon">
                            <i class="icofont-chart-line"></i>
                        </div>
                    </div>
                    <h3>L'évaluation comparative (benchmarking)</h3>
                    <div class="step-content">
                        <p>Comparaison des performances et des pratiques opérationnelles d'un sous-traitant avec celles des meilleures références internationales.</p>
                    </div>
                </div>
            </div>

            <!-- Step 3 -->
            <div class="col-lg-4 mb-4">
                <div class="step-card">
                    <div class="step-header">
                        <div class="step-number">03</div>
                        <div class="step-icon">
                            <i class="icofont-graduation-cap"></i>
                        </div>
                    </div>
                    <h3>Le développement des compétences</h3>
                    <div class="step-content">
                        <div class="competence-steps">
                            <div class="competence-step">
                                <i class="icofont-check-circled"></i>
                                <span>La collecte des éléments de preuve de la compétence avérée du sous-traitant</span>
                            </div>
                            <div class="competence-step">
                                <i class="icofont-check-circled"></i>
                                <span>L'enquête de satisfaction des donneurs d'ordre</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Labels Section -->
        <div class="row mt-5">
            <div class="col-lg-12">
                <div class="labels-section">
                    <div class="section-header">
                        <h3>Labellisation des sous-traitants</h3>
                        <p>Chaque étape du programme d'accompagnement de la BSTP Guinée est une sorte d'évaluation avec des objectifs de conformité et/ou de performance visés. Sur la base de la notation des différents critères du profiling, du benchmarking et du Supply chain management:</p>
                    </div>

                    <div class="labels-table">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>N°</th>
                                        <th>LABEL</th>
                                        <th>NOTES</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td><strong>LABEL NIVEAU I</strong></td>
                                        <td>100</td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td><strong>LABEL NIVEAU II</strong></td>
                                        <td>100</td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td><strong>LABEL NIVEAU III</strong></td>
                                        <td>100</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <div class="note-box">
                            <i class="icofont-info-circle"></i>
                            <p><strong>NB :</strong> Les niveaux des Labels sont indépendants des uns des autres. Toutefois, les entreprises voulant obtenir un Label du niveau II ou du niveau III sont contraintes d'obtenir des Labels du niveau inférieur.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Details Grid -->
        <div class="row mt-5">
            <!-- Eligibility -->
            <div class="col-lg-6 mb-4">
                <div class="detail-card">
                    <div class="card-header">
                        <div class="card-icon">
                            <i class="icofont-user-check"></i>
                        </div>
                        <h4>Éligibilité à la labellisation</h4>
                    </div>
                    <div class="card-content">
                        <p>Sont éligibles à la labellisation, les sous-traitants qui ont suivi avec succès toutes les étapes du programme d'accompagnement de la BSTP ci-dessus. Le label est attribué si les détails à vérifier ont permis d'atteindre un score minimum de 80 points sur les critères définis.</p>
                    </div>
                </div>
            </div>

            <!-- Periodicity -->
            <div class="col-lg-6 mb-4">
                <div class="detail-card">
                    <div class="card-header">
                        <div class="card-icon">
                            <i class="icofont-calendar"></i>
                        </div>
                        <h4>Périodicité et durée de validité</h4>
                    </div>
                    <div class="card-content">
                        <p>Les activités de labellisation sont planifiées et réalisées suivant la démarche standard de la mise en œuvre des missions de la BSTP. Les Labels de compétence décernés ont une durée de vie de 2 ans. Le renouvellement du Label suit le même parcours initial de la labellisation.</p>
                    </div>
                </div>
            </div>

            <!-- Advantages -->
            <div class="col-lg-6 mb-4">
                <div class="detail-card">
                    <div class="card-header">
                        <div class="card-icon">
                            <i class="icofont-crown"></i>
                        </div>
                        <h4>Avantages des sous-traitants labellisés</h4>
                    </div>
                    <div class="card-content">
                        <p>Les sous-traitants ayant réussis avec brio l'ensemble des étapes du programme d'accompagnement de la BSTP et la labellisation présentent une garantie raisonnable de la réalisation efficace des prestations sollicitées par un donneur d'ordre.</p>
                    </div>
                </div>
            </div>

            <!-- Entry Element -->
            <div class="col-lg-6 mb-4">
                <div class="detail-card">
                    <div class="card-header">
                        <div class="card-icon">
                            <i class="icofont-sign-in"></i>
                        </div>
                        <h4>L'élément d'entrée</h4>
                    </div>
                    <div class="card-content">
                        <p>Le déclencheur de l'activité de labellisation est l'élaboration du programme annuel de labellisation réalisé par un Collège des Experts de la BSTP et validé par le Directeur de la BSTP.</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Output Element -->
        <div class="row mt-3">
            <div class="col-lg-12">
                <div class="output-card">
                    <div class="card-header">
                        <div class="card-icon">
                            <i class="icofont-document"></i>
                        </div>
                        <h4>L'élément de sortie</h4>
                    </div>
                    <div class="card-content">
                        <p>L'aboutissement de la présente procédure «labelliser les sous-traitants accompagnés par la BSTP» est la remise du parchemin à chaque sous-traitant ayant satisfait au quota des points exigible par niveau de label sollicité.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- CTA Section -->
<section class="cta-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 text-center">
                <div class="cta-content">
                    <h2>Prêt à obtenir votre label ?</h2>
                    <p>Rejoignez notre programme de labellisation et obtenez la reconnaissance de vos compétences</p>
                    <div class="cta-buttons">
                        <a routerLink="/contact" class="btn btn-primary">
                            <i class="icofont-envelope"></i>
                            Nous contacter
                        </a>
                        <a href="https://www.qualifpme.bstpgn.com" target="_blank" class="btn btn-outline-primary">
                            <i class="icofont-user-plus"></i>
                            Rejoindre QualifPME
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
